module.exports = __webpack_public_path__ + "img/product-center.a5b8ae02.png";